import React, { useContext, useEffect, useState } from "react";

import { VisibilityContext } from "react-horizontal-scrolling-menu";
import { IconButton } from "@mui/material";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";

const Arrow = ({
    children,
    disabled,
    onClick,
}: {
    children: React.ReactNode;
    disabled: boolean;
    onClick: VoidFunction;
}) => {
    return (
        <IconButton
            disabled={disabled}
            onClick={onClick}
            style={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                right: "1%",
                opacity: disabled ? "0" : "1",
                userSelect: "none",
            }}
        >
            {children}
        </IconButton>
    );
};

export const LeftArrow = (): JSX.Element | null => {
    const { isFirstItemVisible, scrollPrev, visibleItemsWithoutSeparators, initComplete } =
        useContext(VisibilityContext);

    const [disabled, setDisabled] = useState(!initComplete || (initComplete && isFirstItemVisible));
    useEffect(() => {
        if (visibleItemsWithoutSeparators.length) {
            setDisabled(isFirstItemVisible);
        }
    }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

    return (
        <Arrow disabled={disabled} onClick={() => scrollPrev()}>
            <ChevronLeftOutlinedIcon style={{ color: "#E6117B" }} />
        </Arrow>
    );
};

export const RightArrow = (): JSX.Element | null => {
    const { isLastItemVisible, scrollNext, visibleItemsWithoutSeparators } =
        useContext(VisibilityContext);

    const [disabled, setDisabled] = useState(
        !visibleItemsWithoutSeparators.length && isLastItemVisible
    );

    useEffect(() => {
        if (visibleItemsWithoutSeparators.length) {
            setDisabled(isLastItemVisible);
        }
    }, [isLastItemVisible, visibleItemsWithoutSeparators]);

    return (
        <Arrow disabled={disabled} onClick={() => scrollNext()}>
            <ChevronRightOutlinedIcon style={{ color: "#E6117B" }} />
        </Arrow>
    );
};
